import React, { Component } from "react";
import { Fragment } from "react";
import FormFlowWrapper from "../../theme/wrappers/FormFlowWrapper";
import _ from "lodash";
import { DateTime } from "luxon";
import api from "../../../store/api";
import {
  toggleGlobalLoader,
  addErrorAlert,
} from "../../../store/calls/alertLoadingDispatch";
import formatters from "../../../utils/forms/formatters";
import { connect } from "react-redux";
import Input from "../../theme/forms/Input";

const USDFormatter = formatters.USDCurrency.formatter;
const percentageFormatter = formatters.percentage.formatter;


class PageBreak extends Component {
  render = () => <div style={{pageBreakAfter: 'always'}}/>
}

class Indicative extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      amortization_term: null,
    };
  }

  componentDidMount() {
    this.setState({
      amortization_term: _.get(this.props, "data.loan_option.attributes", [
        {},
      ])[0].term,
    });
  }

  getScopes = () => {
    const { data } = this.props;
    if (!data) return [];
    const { scopes } = data;
    if (!scopes) return [];

    let arrayScopes = Object.keys(scopes).map((scopeKey) => {
      return {
        id: scopeKey,
        name: _.startCase(scopeKey),
        ...scopes[scopeKey],
      };
    });
    return arrayScopes;
  };

  renderNotes = () => {
    const exceptions = _.get(this.props, "data.district.exceptions", []);

    const loan_product_notes = [
      {
        dataKey: "lender_consent_req",
        display: "Lender Consent Required",
        bool: true,
      },
      {
        dataKey: "pre_payment_penalty",
        display: "Prepayment Penalty",
      },
      {
        dataKey: "application_deposit_desc",
        display: "Application Deposit",
      },
      {
        dataKey: "interest_accrual_before_1st_payment",
        display: "Interest Accrual Before First Payment",
        bool: true,
      },
      {
        dataKey: "progress_payment_before_permit",
        display: "Progress Payment Before Permit",
        bool: true,
      },
      {
        dataKey: "max_loan_to_val_percent_req",
        display: "Max Loan to Value",
      },
      {
        dataKey: "post_pace_clear_equity_percent_req ",
        display: "Max Post-PACE LTV",
      },
      {
        dataKey: "on_line_project_tracking",
        display: "Online Project Tracking",
        bool: true,
      },
      {
        dataKey: "other_notes",
        display: "Other Notes",
      },
    ];

    const program_notes = [
      {
        dataKey: "prop_tax_delinquency_policy",
        display: "Property Tax Delinquency Policy",
      },
      {
        dataKey: "bankruptcy_policy",
        display: "Bankruptcy Policy",
      },
      {
        dataKey: "multi_family_min_units",
        display: "Minimum Number of Units in Multi Family Project",
      },
      {
        dataKey: "lender_consent_req",
        display: "Lender Consent Required",
      },
      {
        dataKey: "refi_ok",
        display: "Accepts Refinance",
      },
      {
        dataKey: "refi_lookback_period",
        display: "Maximum Age of Loans That Can Be Refinanced (years)",
      },
      {
        dataKey: "other_notes",
        display: "Other Notes",
      },
    ];

    const { data } = this.state;
    const writeBool = (bool) =>
      [null, undefined].includes(bool) ? "- -" : bool ? "Yes" : "No";
    return (
      <div className="indicative-resume__details-bottom">
        <h6 className={"is-size-6 mt-4"}>Notes about this PACE Program</h6>
        {program_notes.map((d) => {
          return (
            <p>
              <span className={"has-font-weight-semi-bold"}>{d.display}: </span>
              {d.bool
                ? writeBool(this.props.data.loan_option.pace_program[d.dataKey])
                : this.props.data.loan_option.pace_program[d.dataKey] || "- -"}
            </p>
          );
        })}
        <h6 className={"is-size-6 mt-5"}>Notes about this Funding Product</h6>
        {loan_product_notes.map((d) => {
          return (
            <p>
              <span className={"has-font-weight-semi-bold"}>{d.display}: </span>
              {d.bool
                ? writeBool(this.props.data.loan_option[d.dataKey])
                : this.props.data.loan_option[d.dataKey] || "- -"}
            </p>
          );
        })}

        {!!exceptions.length && (
          <>
            <h6 className={"is-size-6 mt-5"}>Notes for this community</h6>
            {exceptions.map((d) => {
              return <p>{d.text_value}</p>;
            })}
          </>
        )}
      </div>
    );
  };

  renderTop = () => {
    const { data } = this.props;

    return (
      <div className="indicative-resume__details-top">
        <div className={"left"}>
          <img
            src="https://statichouse.pacefi.com/logo/PACEfi-logo_no-bkg.png"
            alt="pacefi-logo"
          />
          <p>
            <b>Proposal Date: </b>{" "}
            {data.created_at}
          </p>
          <p>
            <b>Project Name: </b> {data.project_name}
          </p>
          <p>
            <b>Property Address: </b>
            {_.get(data, "address.formatted_address")}
          </p>
        </div>
        <div className={"right"}>
          <div className="contact">
            {/*<p>Philippe Hartley</p>*/}
            <p>866.824.8442</p>
            <p>admin@cleanfinancing.com</p>
          </div>
          <p>
            <b>Project ID: </b> {data.project_lead_id}
          </p>
          <p>
            <b>Indicative ID: </b> {data.indicative_id}
          </p>
        </div>
      </div>
    );
  };
  renderBottom = () => {
    const { data } = this.props;

    return (
      <Fragment>
        {this.renderNotes()}
        {/*<div className="indicative-resume__details-bottom-sign">*/}
        {/*  <div className="indicative-resume__details-bottom-sign__left">*/}
        {/*    <p>Contact Info: </p>*/}
        {/*  </div>*/}
        {/*  <div className="indicative-resume__details-bottom-sign__right">*/}
        {/*    /!*<p>Philippe Hartley</p>*!/*/}
        {/*    <p>866.824.8442</p>*/}
        {/*    <p>admin@cleanfinancing.com</p>*/}
        {/*  </div>*/}
        {/*</div>*/}
      </Fragment>
    );
  };

  renderAmortizationTable(terms) {
    return (
      <div className="ir-container-secondrow">
        <div className="ir-container-secondrow__headers">
          <div>
            <span>Number</span>
          </div>
          <div>
            <span>Year</span>
          </div>
          <div>
            <span> Interest</span>
          </div>
          <div>
            <span> Principal</span>
          </div>
          <div>
            <span> Balance </span>
          </div>
          <div>
            <span> Payment</span>
          </div>
        </div>
        <div className="ir-container-secondrow__itemscope">
          <div
            className="ir-container-secondrow__itemscope__title"
            style={{ top: "105px" }}
          >
            <span>AMORTIZATION</span>
          </div>
          <div className="ir-container-secondrow__itemscope__container">
            {_.get(
              terms.find((d) => d.term === this.state.amortization_term) || {},
              "schedule",
              []
            ).map((payment, index) => (
              <div className="ir-container-secondrow__itemscope__row">
                <div>
                  <span>{payment.number}</span>
                </div>
                <div>
                  <span>
                    {Math.ceil(
                      payment.number /
                        (this.props.data.loan_option.annual_payment_count || 0)
                    )}
                  </span>
                </div>
                <div>
                  <span>{USDFormatter(payment.interest)}</span>
                </div>
                <div>
                  <span> {USDFormatter(payment.principal)}</span>
                </div>
                <div>
                  <span> {USDFormatter(payment.balance)}</span>
                </div>
                <div className="last-item-scope-loan">
                  <span>{USDFormatter(payment.payment)}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }

  render() {
    const { data } = this.props;
    const terms = _.get(data, "loan_option.attributes", []);

    if (!data || this.state.error)
      return (
          <div>
          {this.state.error && (
            <div className={"card m-4 mt-6"}>
              <div className={"content"}>
                <div
                  className={
                    "is-flex m-4 is-justify-content-center is-align-items-center"
                  }
                >
                  <span
                    className={
                      "icon has-text-danger is-size-2 m-2 mr-5 is-flex is-justify-content-center is-align-items-center"
                    }
                    onClick={() => {}}
                  >
                    <i className={"far fa-times-circle"} />
                  </span>
                  <h4 className={"is-size-5 has-text-danger m-0"}>
                    {this.state.error}
                  </h4>
                </div>
              </div>
            </div>
          )}
          </div>
      );

    return (
        <div id={"indicative-wrapper"}>
        <div className="pagetoprint">
          <div className="container box indicative-resume__container ">
            {this.renderTop()}
            <div className="indicative-resume__bar-separator" />

            <div className="ir-container-firstrow">
              <div className="ir-container-firstrow__left">
                <div className="ir-container-firstrow__left__itemscope">
                  <div className="ir-container-firstrow__left__itemscope__leftcard">
                    <p>Project Cost:</p>



                    <p>Tax Benefits Applied:</p>
                  </div>
                  <div className="ir-container-firstrow__left__itemscope__rightcard">
                    <div>
                      <p className="has-text-primary">
                        {USDFormatter(data.amount)}
                      </p>
                      <p className="has-text-primary">
                        {data.tax_benefits ? '- ' + USDFormatter(data.tax_benefits) : '- -'}
                      </p>
                    </div>
                    <div>{/*<p>ESS Only-pre-SGIP</p>*/}</div>
                  </div>
                </div>
                <div className="ir-container-firstrow__left__totalcost">
                  <p>Project Cost Financed: {USDFormatter(data.amount - (data.tax_benefits || 0))}</p>
                </div>
              </div>
              <div className="ir-container-firstrow__right">
                <div className="ir-container-firstrow__right__columns">
                  <div />
                  <p>Averaged Max Useful Life - Years:</p>
                  <p>Funding Effective Date:</p>
                  <p>Cap-I Accural End Date:</p>
                  <p>Cap-I Days:</p>
                  <p>Annual Payments</p>
                  <p>3rd Party PPA Discount %</p>
                  <span>(solar and storage only)</span>
                </div>
                <div className="ir-container-firstrow__right__itemscope">
                  <div>Overview</div>
                  <p>{data.max_term}</p>
                  <p>{DateTime.fromISO(data.start_date).toFormat("LLLL d")}</p>
                  <p>
                    {DateTime.fromISO(
                      data.loan_option.first_payment_date
                    ).toFormat("LLLL dd")}
                  </p>
                  <p>{Math.abs(data.loan_option.cap_i_days)}</p>
                  <p>{_.get(data, "loan_option.annual_payment_count")}</p>
                  <p>{percentageFormatter((data.tax_benefits / data.amount) * 100)}</p>
                </div>
              </div>
            </div>
            <div className="ir-container-secondrow">
              <div className="ir-container-secondrow__headers">
                <div>
                  <span>Loan Term</span>
                </div>
                <div>
                  <span>Interest Rate</span>
                </div>
                <div>
                  <span> Closing Fees & Costs</span>
                </div>
                <div>
                  <span> Cap-I Accrued Interest </span>
                </div>
                <div>
                  <span> Total Amount Financed</span>
                </div>
                <div>
                  <span>
                    {" "}
                    Payment ({_.get(data, "loan_option.annual_payment_count")}
                    per yr){" "}
                  </span>
                </div>
                <div>
                  <span> Annual Payment</span>
                </div>
              </div>
              <div className="ir-container-secondrow__itemscope">
                <div className="ir-container-secondrow__itemscope__title">
                  <span>TERMS</span>
                </div>
                <div className="ir-container-secondrow__itemscope__container">
                  {terms.map((term, index) => (
                    <div className="ir-container-secondrow__itemscope__row">
                      <div>
                        <span> {term.term}</span>
                      </div>
                      <div>
                        <span>
                          {" "}
                          {percentageFormatter(term.calculated_rate * 100, 2)}
                        </span>
                      </div>
                      <div>
                        <span>{USDFormatter(term.closing_costs)}</span>
                      </div>
                      <div>
                        <span> {USDFormatter(term.cap_i_interest)}</span>
                      </div>
                      <div>
                        <span>{USDFormatter(term.total_amount_financed)}</span>
                      </div>
                      <div>
                        <span>
                          {USDFormatter(
                            _.get(term, "schedule[0].payment", "Err!")
                          )}
                        </span>
                      </div>
                      <div className="last-item-scope-loan">
                        <span>{USDFormatter(term.annual_payment)}</span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div className="indicative-resume__bar-separator" />
            {this.renderBottom()}
          </div>

          <PageBreak/>

          {/* amortization */}
          <div className="container box indicative-resume__container">
            <div className={'no-print'}>
            {this.renderTop()}
            </div>
            <div className="indicative-resume__bar-separator" />

            <div
              className={
                "term-selector-wrapper m-3 is-justify-content-space-between is-flex"
              }
            >
              <h3 className={'is-size-5 has-text-primary ml-2'}>Amortization Schedule</h3>
              <Input
                type={"select"}
                options={terms.map((d) => ({
                  display: d.term + " Year Term",
                  value: d.term,
                }))}
                value={this.state.amortization_term}
                onChange={(val) => this.setState({ amortization_term: +val })}
              />
            </div>
            {this.renderAmortizationTable(terms)}
          </div>

         <PageBreak/>

          <div className="container box indicative-resume__container">
            <div className={'no-print'}>
            {this.renderTop()}
            </div>
            <div className="indicative-resume__bar-separator" />

            <div className={"px-4"}>
              <h4 className={"is-size-5 has-text-primary"}>
                This financing indicative is not a funding offer.
              </h4>
              <p className={"mt-5"} style={{ fontSize: "11px" }}>
                This document is a financing indicative only, based on rates and
                product features offered by participating funders at the moment
                of your inquiry - This document is not a funding offer, but an
                indication of the financing options available for projects like
                yours at the moment of your inquiry.
                <span className={"has-text-weight-semibold"}>
                  The property address listed here may not qualify for reasons
                  of valuation, debt ratio, title issues or multiple other
                  factors.
                </span>
                Your actual payments would be based on pre-underwriting
                findings, the application process, the calendar date the
                financing agreement is signed, changes in points and fees
                associated with this program and financing product at the time
                of your application, PACE program requirement changes, and other
                factors.
                <span className={"has-text-weight-semibold"}>
                  CleanFi makes no representation here about the funding
                  viability of your project.
                </span>
              </p>
            </div>

            <div className="indicative-resume__bar-separator" />
            <div className="indicative-resume__details-bottom-sign">
              <div className="indicative-resume__details-bottom-sign__left">
                <p>Contact Info: </p>
              </div>
              <div className="indicative-resume__details-bottom-sign__right">
                {/*<p>Philippe Hartley</p>*/}
                <p>866.824.8442</p>
                <p>admin@cleanfinancing.com</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  focusedProject: state.projectLeads.focusedProject,
  isAdmin: state.user.decodedTokenData.admin,
});

export default connect(mapStateToProps)(Indicative);
